import type {
  AccountBuyerGetAnimalsQuery,
  AnimalTypeEnum,
  FrequencyType,
  LastVisitType,
  ProfessionalTypeEnum,
  TemperType,
  YesNoUnknownStatus,
} from '@gql/graphql';
import type {
  BuyerAnimalFormProps,
  BuyerAnimalFormValues,
  HeaderProfileData,
  PreBookingWarningData,
  SelectOption,
} from '@presentation/components';
import type { Dayjs } from 'dayjs';
import type { MouseEventHandler, ReactElement } from 'react';

export interface BookingPageFormValues {
  shouldRequirePhoneNumber: boolean;
  phoneNumber?: string;
  bookingReason?: string;
  bookingStart?: Dayjs;
  animalIds: Array<number | 'new'>;
  animalType?: AnimalTypeEnum;
  animals?: BuyerAnimalFormValues[];
  breedId?: number;

  animalRecentlyAdopted?: boolean | undefined;
  animalFirstTimeAtGroomer?: boolean | undefined;
  animalHasKnottedFur?: YesNoUnknownStatus;
  animalLastVisit?: LastVisitType;
  animalBrushingFrequency?: FrequencyType;
  animalTemper?: TemperType;
}

export interface BookingPageOptions {
  breedOptions: SelectOption<number>[];
  animalOptions: SelectOption<number>[];
}

export interface BookingPageProData {
  id?: number;
  type: ProfessionalTypeEnum;
  title?: string;
  service?: string;
  workerName?: string;
  serviceDuration?: number;
  servicePrice?: string;
  image?: string;
  address?: string;
}

export interface BookingPageProps {
  header: HeaderProfileData;
  onAuthFormClick: () => void;
  pro: BookingPageProData;

  preBookingWarning?: PreBookingWarningData;

  shouldRequirePhoneNumber?: boolean;

  currentStep: number;
  onNextClick?: MouseEventHandler;
  onPreviousClick?: MouseEventHandler;
  onEditInfoClick?: MouseEventHandler;

  accountAnimals?: NonNullable<AccountBuyerGetAnimalsQuery['accountMe']>['animals'];

  animalFormComponentProps: (selectedAnimalId?: number | 'new') => BuyerAnimalFormProps;

  formOptions: {
    animalOptions: SelectOption<number | 'new'>[];
  };

  loginForm: ReactElement;
  joinBuyerForm: ReactElement;

  chosenAuth?: BookingPageAuthMethod;
  onChosenAuthChange?: (auth: BookingPageAuthMethod | undefined) => void;

  forMultiAnimals: boolean;

  animalsLoading?: boolean;
}

export type BookingPageAuthMethod = 'login' | 'register';
